import Vue from 'vue'
// initial state
const state = {
}
// getters
const getters = {
  show: state => state.show
}
const actions = {
  getLabel({ commit, state, getters, dispatch }, payload) {
    return new Promise((resolve) => {
      let self = this;
      if (payload !== undefined) {
        //ESTRAGGO IL NOME DEL NODO CHE CONTIENE L'ID
        //ESCLUDENDO IL CAMPO FONTE
        let idContainer = {};
        idContainer = Object.keys(payload).filter(function (chiave) {
          return chiave !== 'fonte'
        });
        var pointer =
          (payload.fonte === 'esterno' ? 'Altro_mondo' : ("Utenti/" + this.state.loginStates.userDettails.uid)) + "/" + "labels";
        this.databaseOps.db
          .ref(pointer)
          .child(payload[idContainer])
          .on("value", function (snapshot) {
            var item = snapshot.val();
            if (item !== null && item !== undefined) {
              //DOVREI AGGIUNGERE ANCHE UN CONTROLLO TIMEOUT SE NON TROVA IL NODO
              //self.marca = item
              let obj = {}
              obj.label = item
              obj.category = idContainer[0]
              obj.id = payload[idContainer]
              resolve(obj)

            }
          });
      }
    })
  },
  addQuantity({ commit, state, getters, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      var qty = parseInt(payload.qty)
      var cost = parseFloat(payload.cost)
      //PREPARO IL PAYLOAD PER LA MUTAZIONE
      var mutationPayload = Object.assign(payload, { cleanCache: false });
      this.databaseOps.db.ref('Utenti/' + this.state.loginStates.userDettails.uid + '/ricambi/' + payload.itemID).child('stock').transaction((stock) => {
        if (stock) {
          let exQty = stock.qty
          let exCosto = stock.costo
          stock.qty = stock.qty + qty
          if (stock.m_flag < 3)//IL NUMERO MASSIMO DI TRANSAZIONI CHE VOGLIO TENERE
          {
            stock.m_flag = stock.m_flag + 1
          } else {
            mutationPayload.cleanCache = true
          }
          if (stock.qty === 0) { stock.costo = cost } else {
            let oldItemsTotalCost = (exQty * exCosto) || 0 // (|| 0) per evitare NAN in caso costo sia 0
            let newItemsTotalCost = qty * cost
            let totalCost = oldItemsTotalCost + newItemsTotalCost
            let averageCost = totalCost / (exQty + qty)
            stock.costo = averageCost.toFixed(2);
          }
        } else {
          stock = {}
          stock.qty = qty
          stock.costo = cost
          stock.m_flag = 1
        }
        return stock

      }).then(response => { dispatch('writeQTYmutation', mutationPayload), resolve() }, error => { reject(error) })
    })

  },
  writeQTYmutation({ commit, state, getters, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let self = this
      let obj = { 'itemID': payload.itemID, 'qty': payload.qty, 'cost': payload.cost, timestamp: (new Date().getTime()) }

      var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'stockMutations'
      var key = this.databaseOps.db.ref(pointer).push().key
      this.databaseOps.db.ref(pointer).child(key).set(obj, function (error) {
        if (error) reject('errore')
        else {
          if (payload.cleanCache === true) {

            var ref = 'Utenti/' + self.state.loginStates.userDettails.uid + '/' + 'stockMutations'
            self.databaseOps.db.ref(ref).orderByChild('itemID').startAt(payload.itemID).limitToFirst(1).once('value').then(function (snapshot) {
              let oggetto = snapshot.val()

              let chiavi = Object.keys(oggetto)
              let idMutazione = chiavi[0]
              self.databaseOps.db.ref(ref).child(idMutazione).remove()
            });

          }
          resolve('fatto')
          //console.log('ricambio aggiunto al nodo interno')
          // self.uploadImmagine(self.ricambio.id,self.immagini[0])
        }
      })
    })
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
